import { useContext, useState, useEffect } from 'react';
import { StoreContext } from '../../store';
import './index.css';

import { ReactComponent as QuickSearch } from '../../assets/quick-search.svg';
import { ReactComponent as Close } from '../../assets/close-icon.svg';
import { ReactComponent as Search } from '../../assets/search.svg';

import Show from '../../utility/Show';
import MarkerList from '../Map/marker-list';
import { CategorySearch } from '../../utility/CategorySearch';

const MapQuickSearch = ({ showResults=true, className="", defaultInput=1 }) => {
  const { state, dispatch, actions } = useContext(StoreContext);
  const { originalMarkers, isEstablishmentSearchOpen, categoryFilters, isExploreEnabled } = state;
  const getMarker = originalMarkers;

  const paddedCategories = () => {
    const initial = categoryFilters.length > 0 ? [...categoryFilters] : [''];
    const missingCount = Math.max(defaultInput - initial.length, 0);
    return [...initial, ...Array(missingCount).fill('')];
  };

  const [categories, setCategories] = useState(paddedCategories());
  const [filteredMarkers, setFilteredMarkers] = useState([]);

  useEffect(() => {
    handleChange(categories);
  }, [originalMarkers]);

  const isCategoryExists = (categories) => {
    return categories.some((item) => categoryFilters.includes(item));
  };

  const setFilters = (newCategory, index) => {
    const rawValue = newCategory?.target?.value ?? newCategory?.value ?? newCategory;
    const value = rawValue || '';
  
    const updatedCategories = [...categories];
    updatedCategories[index] = value;
    setCategories(updatedCategories);
  
    dispatch({ type: 'UPDATE_CATEGORY', payload: { index, value } });
  };

  const handleChange = (updatedList) => {
    const result = (updatedList || []).flatMap((text) => {
      const search = actions.normalizeCategories(text)
      if (!search) return []

      return (getMarker || []).filter((marker) => {
        const markerName = actions.normalizeCategories(marker.name) || ''
        const markerCategory = actions.normalizeCategories(marker.category) || 'others'
        return markerName.includes(search) || markerCategory.includes(search)
      })
    })

    const uniqueMarkers = Array.from(
      new Map(result.map((item) => [item.id, item])).values()
    )

    setFilteredMarkers(uniqueMarkers)
  }

  const handleAdd = () => {
    setCategories([...categories, '']);
  };

  const handleClear = (index) => {
    const updated = [...categories];
    updated.splice(index, 1);
    setCategories(updated);
    handleChange(updated);
  };

  const closeMapQS = () => {
    dispatch({ type: 'SET_SHOW_MAP_QS', payload: false });
    dispatch({ type: 'RESET_CATEGORY', payload: [''] });
  };

  return (
    <>
      <div className={`map-qs h-auto min-h-[fit-content] ${className}`}>
        <div className='qs-header'>
          <div className="flex items-start">
            <QuickSearch />
            <div className="flex flex-col">
              Multiple Search
              {/* <span className="italic text-xs">Search for lifestyle essentials important to you</span> */}
            </div>
          </div>
          <Show.When isTrue={!isEstablishmentSearchOpen}>
            <Close className="cursor-pointer close" onClick={closeMapQS} />
          </Show.When>
        </div>

        <div className="category-inputs w-full flex flex-col gap-4">
          {categories.map((cat, index) => (
            <div key={index} className="flex items-center gap-2">
              <span className="w-6">S{index + 1}</span>
              <CategorySearch
                key={`category-filter-${index}`}
                index={index}
                value={cat}
                placeholder="Enter an establishment"
                isClearable
                onClear={() => handleClear(index)}
                onClick={() => {}}
                onChange={(e) => {
                  const newVal = e.target?.value || e;
                  setFilters(newVal, index);
                  handleChange([...categories.slice(0, index), newVal, ...categories.slice(index + 1)]);
                }}
                dispatch={dispatch}
              />
            </div>
          ))}

          {categories.length < 5 && (
            <div className="w-full flex items-center gap-2">
              <span className="w-6 invisible">0</span>
              <button
                onClick={handleAdd}
                className="border border-white w-full rounded text-white text-xl"
              >
                +
              </button>
            </div>
          )}
        </div>
      </div>

      <Show.When
        isTrue={
          categoryFilters?.some((cat) => String(cat || '').trim() !== '') &&
          filteredMarkers.length > 0 &&
          showResults
        }
      >
        <MarkerList markers={filteredMarkers} className="max-w-[430px] bg-[#0D0D0DD9]" />
      </Show.When>
    </>
  );
};

export default MapQuickSearch;
